import {
  AVATAR_SM_WIDTH,
  getResizedImageUrl,
} from '@rolebase/shared/helpers/getResizedImageUrl'
import { Avatar, AvatarProps, Center } from '@chakra-ui/react'
import { SearchTypes } from '@rolebase/shared/model/search'
import React from 'react'
import { TbCircles } from 'react-icons/tb'
import {
  CircleIcon,
  CirclePick,
  DecisionIcon,
  MeetingIcon,
  MemberIcon,
  RoleIcon,
  TaskIcon,
  ThreadIcon,
} from 'src/icons'
import { SearchItem } from '../searchTypes'

interface Props {
  item: SearchItem
  size?: AvatarProps['size']
}

export const searchIcons = {
  Member: MemberIcon,
  Role: RoleIcon,
  Circle: CircleIcon,
  Thread: ThreadIcon,
  Meeting: MeetingIcon,
  Task: TaskIcon,
  Decision: DecisionIcon,
  PickCircle: CirclePick,
}

export default function SearchResultIcon({ item, size }: Props) {
  if (item.type === SearchTypes.Member) {
    return (
      <Avatar
        name={item.title}
        src={getResizedImageUrl(item.picture, AVATAR_SM_WIDTH) || undefined}
        size={size === 'sm' ? 'xs' : 'sm'}
        ml="-8px"
      />
    )
  }
  // « Nobody » gets an empty grey avatar, so it lines up with the members
  // listed under it (#108)
  if (item.type === SearchTypes.ClearAction) {
    return (
      <Avatar
        bg="gray.300"
        _dark={{ bg: 'whiteAlpha.300' }}
        icon={<span />}
        size={size === 'sm' ? 'xs' : 'sm'}
        ml="-8px"
      />
    )
  }
  if (item.type === SearchTypes.CreateAction) {
    return null
  }

  const iconSize = size === 'sm' ? '20px' : '24px'

  // ORG-01 in search results: circle items get the TbCircles glyph, leaf-role
  // items get no icon. `isCircle` is only set by useCircleSearchItems (the
  // circle/role picker pipeline); when it's undefined (e.g. the #7 Algolia
  // global search, which doesn't carry this distinction), fall back to the
  // fixed per-type icon so that pipeline stays visually unchanged.
  if (item.type === SearchTypes.Circle && item.isCircle !== undefined) {
    if (!item.isCircle) return null
    return (
      <Center w={iconSize} h={iconSize}>
        <TbCircles size={iconSize} />
      </Center>
    )
  }

  const Icon = searchIcons[item.type]

  return (
    <Center w={iconSize} h={iconSize}>
      <Icon size={iconSize} />
    </Center>
  )
}
